/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favCreateTicket.vue?vue&type=template&id=45519db5&scoped=true&"
import script from "./favCreateTicket.vue?vue&type=script&lang=js&"
export * from "./favCreateTicket.vue?vue&type=script&lang=js&"
import style0 from "./favCreateTicket.vue?vue&type=style&index=0&id=45519db5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45519db5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VHover,VImg})
